import React, { useState, useEffect } from 'react';
import { useTranslation } from "react-i18next";
import RequirePassword from "@/common/customer.additional-data-fields/RequirePassword";
import SaveButton from "@/common/customer.additional-data-fields/SaveButton";
import { getPlatform } from "@/hooks";

const { Customer, UI } = Mobi2Go;
const { requestOptIn } = Customer.SpoonityLoyalty;

const Spoonity = ({ baseClass, closeModal }) => {
    const [password, setPassword] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [isSuccess, setIsSuccess] = useState(false);

    const [t] = useTranslation('loyalty');

    useEffect(() => {
        if (isSuccess) {
            Customer.trigger('updateLoyalty');

            if (getPlatform() === 'web') {
                closeModal();
            } else {
                UI.trigger('showCustomerProfile');
            }
        }
    }, [isSuccess])

    const onSave = async () => {
        setIsLoading(true);

        try {
            const result = await requestOptIn(password);

            setIsLoading(false);

            if (result) {
                setIsSuccess(true);
            }
        } catch (err) {
            setIsLoading(false);
            setPassword('');

            const invalid_password = err.status === 401; // unauthorised
            const password_requirements_not_met = err.status === 400; // bad request

            if (invalid_password) {
                invalidPasswordWarning();
            } else if (password_requirements_not_met) {
                passwordDoesNotMeetRequirementsWarning();
            } else {
                throw err;
            }
        }
    }

    const passwordDoesNotMeetRequirementsWarning = () => {
        UI.centeredAlert({
            title: t('password_change_required'),
            body: t('more_secure_password'),
            temp: false,
            primary_button: t('common:ok')
        });
    }

    const invalidPasswordWarning = () => {
        UI.centeredAlert({
            title: t('customer.password-updater:invalid_current_password_alert_title'),
            body: t('customer.password-updater:invalid_current_password_alert_body'),
            temp: false,
            primary_button: t('common:ok')
        });
    }

    const onKeyDown = e => {
        if (e.keyCode === 13) {
            onSave();
        }
    }

    return (
        <>
            <RequirePassword
                password={password}
                handleChange={setPassword}
                baseClass={baseClass}
                isRefreshing={isLoading}
                promptText={isSuccess ? '' : t('opt_in_confirmation')}
                savingText={t('opt_in_saving')}
                policyLink={isSuccess ? '' : t('opt_in_confirmation_link')}
                isSuccess={isSuccess}
                closeModal={closeModal}
                onKeyDown={onKeyDown}
            />

            <SaveButton
                handleSave={onSave}
                text={t('opt_in_button')}
                baseClass={baseClass}
                saveButtonDisabled={!password || isLoading || isSuccess}
            />
        </>
    );
}

export default Spoonity;
